/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1);


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* global Foundation */

jQuery(document).ready(function ($) {
  jQuery(document).foundation();

  $('.header-menu__item').on('click', function (event) {
    if ($(event.currentTarget).hasClass('header-menu__item')) {
      var $submenu = $(this).find('.header-menu__submenu');
      var isVisible = $submenu.hasClass('visible');
      $('.header-menu__submenu').removeClass('visible');

      if (!isVisible) {
        $submenu.addClass('visible');
      }

      $('body').toggleClass('is-menu-open');

      return true;
    } else {
      return false;
    }
  });

  $('body').on('click', function (event) {
    if (!$(event.target).hasClass('header-menu__item') && !$(event.target).parent().hasClass('header-menu__item')) {
      $('.header-menu__submenu.visible').removeClass('visible');
      $('body').removeClass('is-menu-open');
    }
  });

  var $sticky = $('.toc__sticky-container');
  if (Foundation.MediaQuery.atLeast('large')) {
    if ($sticky.length > 0) {
      new Foundation.Magellan($sticky, {
        offset: $('.toc').height()
      });

      var marginTop = 0;
      if ($('body').hasClass('logged-in')) {
        marginTop = 1.8;
      }

      new Foundation.Sticky($sticky, {
        topAnchor: 'overview:top',
        btmAnchor: 'toc-bottom:bottom',
        marginTop: marginTop
      });
    }
  }

  $('iframe').each(function (idx, element) {
    iFrameResize({ log: false }, element);
  });
});

/***/ })
/******/ ]);